// Module
var code = "<div class=\"provider-loading-submission\"> <div class=\"logo\" ng-show=\"!vm.isOnlineLodgement\"> <img ng-src=\"assets/images/bluestone/lender-select.png\"/> </div> <div class=\"loader\"> <preloader-dot preloader-size=\"lg\"></preloader-dot> </div> <div class=\"label-loading\"> Submitting application </div> </div> ";
// Exports
module.exports = code;